// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1kwWE","info":"UpdateTermsInfo_info__Ks9SL"};